import React from 'react';
import { useState } from 'react';
import { ABOUTUS } from '../API/Config';
import Header from '../Layouts/Header';
import Footer from '../Layouts/Footer';
import bgImage from '../Assets/Images/main-bg.jpg';
import { FaArrowDown } from "react-icons/fa";
import CircularText from '../Components/CircularText';
import { PiRocketLaunchLight } from "react-icons/pi";
import { PiRocketLaunchFill } from "react-icons/pi";
import Partners from '../Components/Partners';
import { toast } from 'react-hot-toast';
import TeamSection from '../Components/TeamSection';


const AboutUs = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    industry: "",
    howcanwehelpyou: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(ABOUTUS, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Form submitted successfully!");
        setFormData({
          firstname: "",
          lastname: "",
          email: "",
          industry: "",
          howcanwehelpyou: ""
        });
      } else {
        toast.error(result.message || "Submission failed");
      }
    } catch (err) {
      toast.error("Error submitting form");
      console.error(err);
    }
  };





  // Smooth scroll function
  const handleScroll = () => {
    const section = document.getElementById('scrollDown');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToForm = () => {
    const section = document.getElementById('scrollToForm');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Header />

      {/* Hero Section */}
      <div
        className="relative h-screen flex items-center justify-center text-white pt-[6%]"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black opacity-55"></div>

        {/* Content */}
        <div className="relative z-10 text-center">
          <h1 className="text-4xl md:text-6xl font-bold">WHO WE ARE</h1>
          <div className="w-24 h-1 bg-white mx-auto my-4"></div>
          <h2 className="text-2xl md:text-4xl font-semibold mb-8">About us</h2>

          {/* Circular Spinner Text with Centered Arrow */}
          <div className="relative w-28 h-28 mx-auto flex items-center justify-center mt-[30%]">
            {/* Rotating CircularText Layer */}
            <div onClick={handleScroll} className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
              <CircularText
                text="VIVEKASOFTEK @ EXPLORE  "
                spinDuration={20} // seconds
              />
            </div>

            {/* Center Arrow */}
            <div className="z-10 flex items-center justify-center">
              <button onClick={handleScroll}>
                <FaArrowDown size={28} className="text-white" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div id="scrollDown" className="bg-white text-black py-[5%] px-[10%]">
        <div className="max-w-screen-xl mx-auto px-4">
          <h2 className="text-3xl font-bold mb-6 text-center">
            Empowering Your Business with Technology
          </h2>
          <p className="text-lg leading-8 font-medium text-justify">
            At Vivekasoftek, we began with a simple belief: technology can transform businesses.
            Founded in Madurai, we have grown into a leading software technology company,
            providing Application Services, Automation, Digital Marketing, and Software Engineering
            to clients across industries.
          </p>
          <p className="text-lg leading-8 mt-4 font-medium text-justify">
            Our journey is built on innovation, dedication, and the goal of helping businesses
            work smarter, grow faster, and stay ahead in today’s competitive digital world. From
            custom web and mobile applications to enterprise software solutions and data-driven
            marketing strategies, we deliver end-to-end IT services that drive real business growth.
          </p>
        </div>
      </div>

      {/* Third Section - Reusing Hero Background */}
      <div
        className="relative text-white py-24 px-6 md:px-12"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
        }}
      >
        {/* Overlay for dark background */}
        <div className="absolute inset-0 bg-black opacity-60"></div>

        <div className="relative z-10 text-white py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">

            {/* Column 1 - Centered Heading */}
            <div className="flex justify-center items-center">
              <h2 className="text-4xl md:text-5xl font-bold text-center">Why Vivekasoftek</h2>
            </div>

            {/* Column 2 - Features */}
            <div className="space-y-8">
              {/* Expertise */}
              <div>
                <h3 className="text-2xl font-bold mb-2">Expertise</h3>
                <p className="font-medium leading-relaxed text-justify">
                  Our Team Consists of Seasoned Professionals with a Wealth of Experience in their Respective Fields, ensuring that You Receive Top-Notch Service and Unparalleled Expertise.
                </p>
              </div>

              {/* Innovation */}
              <div>
                <h3 className="text-2xl font-bold mb-2">Innovation</h3>
                <p className="font-medium leading-relaxed text-justify">
                  We Stay ahead of the Curve by Embracing the Latest Technologies and Trends, Allowing Us to Deliver Innovative Solutions that Set You apart from the Competition.
                </p>
              </div>

              {/* Results-Driven */}
              <div>
                <h3 className="text-2xl font-bold mb-2">Results-Driven</h3>
                <p className="font-medium leading-relaxed text-justify">
                  We are Driven by Results. Whether it's Increasing Brand Awareness, Driving Traffic to Your Website, or Boosting Sales, We Focus on Delivering Tangible Outcomes that Drive Your Success.
                </p>
              </div>
            </div>
          </div>
        </div>


        {/* Main Content */}
        <div className="relative z-10 max-w-screen-xl mx-auto flex flex-col space-y-16">
          {/* Title and Text Block */}
          <div className="flex flex-col items-start space-y-10 w-full">
            <p className="uppercase tracking-wide font-semibold text-sm text-white">
              OUR PEOPLE
            </p>

            <div className="flex items-start gap-4">
              {/* Blue Vertical Line */}
              <div className="w-1 bg-blue-500 rounded h-full mt-1" />

              <div>
                <h2 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
                  How do you create a<br />remarkable change?
                </h2>
                <p className="text-lg md:text-xl font-medium max-w-2xl leading-relaxed">
                  At <strong>VIVEKASOFT</strong>, we believe exceptional work begins with hiring, celebrating, and nurturing the best people — from all walks of life.
                </p>
                <TeamSection />
              </div>
            </div>

            {/* Join Us Button Centered */}
            <div className="w-full flex justify-center">
              <button
                className="flex items-center gap-2 text-white border border-white rounded-full px-5 py-2 hover:bg-[#ffffff30] transition duration-300"
                onClick={scrollToForm}
              >
                Join us
                <div className="w-8 h-8 bg-white text-black rounded-full flex items-center justify-center">
                  <FaArrowDown size={16} className="animate-bounce" />
                </div>
              </button>
            </div>
          </div>

          <Partners />



        </div>
      </div>

      {/* Contact Form Section */}
      <div id='scrollToForm' className="bg-white text-black py-20 px-6 md:px-12">
        <div className="max-w-screen-md mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Have any projects in mind?<br className="hidden md:inline" />
            Get in touch with us!
          </h2>

          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* Row 1: First & Last Name */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block font-medium mb-1" htmlFor="firstName">
                  First Name
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstname"
                  value={formData.firstname}
                  onChange={handleChange}
                  required
                  className="w-full font-medium border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

              </div>

              <div>
                <label className="block font-medium mb-1" htmlFor="lastName">
                  Last Name
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastname"
                  value={formData.lastname}
                  onChange={handleChange}
                  required
                  className="w-full font-medium border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

              </div>
            </div>

            {/* Row 2: Email */}
            <div>
              <label className="block font-medium mb-1" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full font-medium border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

            </div>

            {/* Row 3: Industry with "Other" option */}
            <div>
              <label className="block font-medium mb-1" htmlFor="industry">
                Industry
              </label>
              <select
                id="industry"
                name="industry"
                value={formData.industry}
                onChange={handleChange}
                className="w-full font-medium border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 text-[14px]"
              >
                <option value="">Select an industry</option>
                <option value="Technology">Technology</option>
                <option value="Healthcare">Healthcare</option>
                <option value="Education">Education</option>
                <option value="Finance">Finance</option>
                <option value="Life sciences">Life sciences</option>
                <option value="Insurance">Insurance</option>
                <option value="High tech">High tech</option>
                <option value="Retail">Retail</option>
                <option value="Manufacturing">Manufacturing</option>
                <option value="Public services">Public services</option>
                <option value="Travel and Logistics">Travel and Logistics</option>
                <option value="Others">Others</option>
              </select>



              {/* Conditionally shown if "Other" is selected */}
              <div id="otherIndustryField" className="hidden mt-4">
                <input
                  type="text"
                  placeholder="Please specify your industry"
                  className="w-full font-medium border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            {/* Row 4: Message */}
            <div>
              <label className="block font-medium mb-1" htmlFor="message">
                How can we help you?
              </label>
              <textarea
                id="message"
                name="howcanwehelpyou"
                value={formData.howcanwehelpyou}
                onChange={handleChange}
                rows="3"
                required
                className="w-full font-medium border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

            </div>

            {/* Submit Button */}
            <div className="pt-4 text-right">
              <button
                type="submit"
                className="relative bg-black text-white px-6 py-3 rounded-full font-semibold transition duration-300 group"
                style={{ width: "140px" }}
              >
                <div className="relative flex items-center justify-center">
                  {/* Icons */}
                  <span className="absolute left-0 top-1/2 -translate-y-1/2 text-xl text-white transition-all duration-300 group-hover:left-1/2 group-hover:translate-x-[-50%]">
                    {/* Default Icon */}
                    <span className="transition-opacity duration-300 opacity-100 group-hover:opacity-0">
                      <PiRocketLaunchLight />
                    </span>

                    {/* Hover Icon */}
                    <span className="absolute inset-0 transition-opacity duration-300 opacity-0 group-hover:opacity-100">
                      <PiRocketLaunchFill />
                    </span>
                  </span>

                  {/* Text */}
                  <span className="transition-all ml-5 duration-300 group-hover:opacity-0">
                    Send
                  </span>
                </div>
              </button>
            </div>


          </form>
        </div>
      </div>

      <Footer />


    </>
  );
};

export default AboutUs;
